import { routes } from '@shared/constants/routes'
import { GuestHasCartQuery } from '@/features/shared/constants/ungatedParams'
import { type ParsedUrlQuery } from 'node:querystring'
import { getSearchQueryString } from '@/features/shared/utils/url'

export const getCartConversionRoute = (queryParams: ParsedUrlQuery) => {
  const params = new URLSearchParams()
  params.set('guest', GuestHasCartQuery)

  if (queryParams.from) {
    params.set('from', queryParams.from.toString())
  }
  return `${routes.CART_CONVERSION_LOADING.url}${getSearchQueryString(params)}`
}
